var exports = {
  "k": "container__v-xCpD",
};

module.exports = exports;
